import {stringMixin} from "../../utils/strings";
import {percentReturn} from "../../utils/math";


const PORTFOLIO_CHANGE_PROMPT = `
    Identify the tickers that changed in the portfolio across snapshots whether being moved into or out of, and explain
    in client-friendly languaging how the portfolios changes benefitted the client. If the portfolio outperformed the benchmark
    and most of the holding options, discuss moves that led to this, if the portfolio underperformed, find areas that
    still highlight the advisor and talk about those such as holdings that still did worse, or consistency and stability,
    that might have resulted in lower returns but smoother path. Make sure to highlight the key stats whether returns % or 
    weight change % for the key details.`

const formatSnapshotRow = (snapshot)=>{
    const rows = [];
    for (let ticker in snapshot){
        rows.push([ticker, snapshot[ticker].wgt]);
    }
    rows.sort((a, b)=>{return b[1]-a[1]});
    const strings = rows.filter(row=>row[1]>0)
                        .map(row=>`${row[0]} % Weight: ${stringMixin.pct(row[1])}`);
    return strings.join('\r\n');
}


/**
 *
 * @param rows {Array[Array]} Array of rows in format:
 *                            [
 *                              [<timestamp>, <portolioValue>, <snapshot>, <benchmarkValue>, <extraSymbols: Array[String]>],
 *                              [...],
 *                              ...
 *                            ]
 */
export const getPortfolioChangesPrompt = (rows, extraHeaders)=>{
    let promptString = `INSTRUCTIONS: ${PORTFOLIO_CHANGE_PROMPT}\r\n\n`;
    promptString += `\r\n\nDATA\r\n\nInitial Portfolio\r\nDate: ${rows[0][0]}\r\nSnapshot: ${formatSnapshotRow(rows[0][2])}\r\n\n`;
    let formattedRows = [];
    for (let i=1; i<rows.length; i++){
        const portfolioReturn = percentReturn(rows[i][1], rows[0][1]);
        const benchmarkReturn = percentReturn(rows[i][3], rows[0][3]);
        let tempRow = [rows[i][0], portfolioReturn, rows[i][2], benchmarkReturn];
        let extraReturnsString = '';
        if (rows[i].length > 3 && Array.isArray(extraHeaders)){
            extraHeaders.forEach((header, index)=>{
                const extraReturn = percentReturn(rows[i][3+index], rows[0][3+index]);
                extraReturnsString += `\r\n${header} % Return: ${stringMixin.pct(extraReturn)}`;
                tempRow.push(extraReturn);
            });
        }
        formattedRows.push(tempRow);
        let innerString = `Next Date: ${rows[i][0]}\r\nSnapshot: ${formatSnapshotRow(rows[i][2])}\r\nPortfolio Return: ${stringMixin.pct(portfolioReturn)}\r\nBenchmark Return: ${stringMixin.pct(benchmarkReturn)}\r\n`;
        if (extraReturnsString.length > 0){
            innerString += extraReturnsString;
        }
        promptString += `\r\n#Next Snapshot[[${innerString}]]\r\r\n`;
    }

    return {
        promptString,
        rows: [['Date', 'Portfolio Value', 'Snapshot', 'Benchmark Value', ...extraHeaders], ...formattedRows]
    };
}